import api from '../baseApi.js'
import { unwrap } from '../helpers.js'

export const authApi = {
  login: (credentials) => api.post('/auth/login', credentials).then(unwrap),
  sendOtp: (payload) => api.post('/auth/otp/send', payload).then(unwrap),
  verifyOtp: (payload) => api.post('/auth/otp/verify', payload).then(unwrap),
  sendActionOtp: (payload) => api.post('/auth/action-otp/send', payload).then(unwrap),
  verifyActionOtp: (payload) => api.post('/auth/action-otp/verify', payload).then(unwrap),
  googleLogin: (payload) => api.post('/auth/google', payload).then(unwrap),
  logout: () => api.post('/auth/logout').then(unwrap),
  me: () => api.get('/auth/me').then(unwrap),
  changePassword: (data) => api.put('/auth/change-password', data).then(unwrap),
}
